// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3ew4r","list":"BalanceDue_list__1e3r1","listRow":"BalanceDue_listRow__2iL2P","total":"BalanceDue_total__3mQkO"};